import Vue from 'vue'
import Router from 'vue-router'
// import { createWebHistory } from 'vue-router'

Vue.use(Router)
//防止路由重复报错
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

const routes = [
  {
    path: '/login',
    name: 'login',
    component: function () {
      return import(/* webpackChunkName: "about" */ '../views/login.vue')
    }
  },
  {
    path: '/index',
    name: 'index',
    component: function () {
      return import(/* webpackChunkName: "about" */ '../views/index.vue')
    }
  },
  {
    path: '/invitation',
    name: 'invitation',
    component: function () {
      return import(/* webpackChunkName: "about" */ '../views/invitation.vue')
    }
  }
]

const router = new Router({
  // mode: 'history',
  routes: routes
})

// 路由守卫
router.beforeEach((to, from, next) => {
  const isLogin = localStorage.token ? true : false;

  if (to.path == "/login" || to.path == "/invitation") {
    next();
  } else {
    if (isLogin) {
      if (to.path == '/') {
        next("/index")
      } else {
        next()
      }
    } else {
      next("/login")
    }
  }
  next();
});

export default router
